<script>
import LineChartCore from "./linechart-core.js";
import ChartWrapper from '@bit/maxthemillion.d3charts.c-wrapper'

export default {
  name: "LineChart",
  mixins: [LineChartCore, ChartWrapper]
};
</script>

